import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { GetGlycerinMkzFragmentDoc } from '@packages/gql/generated/shopping/GetGlycerinMkzFragmentDoc';

/* GraphQL */ `
  fragment GetGlycerinMkz on Product {
    marketcode
  }
`;

export type GetGlycerinMkzProps = FragmentType<typeof GetGlycerinMkzFragmentDoc>;

export const getGlycerinMkz = (data: GetGlycerinMkzProps) => {
  const { marketcode } = getFragmentData(GetGlycerinMkzFragmentDoc, data);

  return { categoryMkz: marketcode?.toString() || '' };
};
